export class AuthConfig {
    constructor(
        public basicToken: string,
        public refreshUrl: string,
        public whitelistedDomains: Array<string | RegExp>,
    ) {}
}
